<template>
  <div class="o-form__block">
    <div class="m-field">
      <div class="m-field__label">{{ label }}</div>
      <textarea
        :value="value"
        @change="(v) => $emit('input', v.target.value)"
        class="a-textarea"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "OQTextInput",
  components: {},
  props: ["label", "hint", "title", "placeholder", "value"],
};
</script>

<style scoped lang="scss"></style>
